import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import { FaCheckCircle } from "react-icons/fa";
import FooterOne from "../components/FooterFour";
import NavBar from "../components/NavbarTwo";

const Career = () => {
  const whyEvolvelab = [
    "Work on real startups, real products, real outcomes",
    "Operate at the intersection of strategy, technology, and funding",
    "Hands-on execution — not slide-deck consulting",
    "Exposure across AI, biotech, healthcare, and emerging tech",
    "Flexible, remote, and project-based opportunities"
  ];

  const whoWeLookFor = [
    "Product leaders & strategists",
    "Full-stack, AI, and cloud engineers",
    "Designers, operators, and growth thinkers",
    "Mentors, advisors, and fractional leaders"
  ];

  const whatYouGet = [
    "Meaningful ownership and responsibility",
    "Accelerated learning across stages and industries",
    "Direct impact on founder and company outcomes",
    "Long-term collaboration opportunities"
  ];

  return (
    <>
      <SEO canonical="/careers" {...PAGES["/careers"]} />
      <NavBar />
      <div className="contact-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="contact-page-inner bg-gray">
            <div className="section-title mb-5 text-center">
              <h1 className="title mb-3">Build What Matters. Shape What's Next.</h1>
              <p className="content mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
                Evolvelab works with founders and leadership teams to build fundable, scalable businesses at the intersection of technology, AI, and innovation.
              </p>
              <p style={{ fontSize: '1rem', fontWeight: '500', color: '#50af9b' }}>
                If you care about clarity, execution, and impact, you'll fit right in.
              </p>
            </div>

            {/* Why Evolvelab */}
            <div className="row mb-5">
              <div className="col-12">
                <h2 className="mb-4" style={{ color: '#222', fontWeight: '700' }}>Why Evolvelab</h2>
                <ul className="single-list-inner style-check mb-4">
                  {whyEvolvelab.map((item, index) => (
                    <li key={index} style={{ fontSize: '1rem', lineHeight: '1.8', marginBottom: '12px' }}>
                      <FaCheckCircle style={{ color: '#50af9b' }} /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Who We're Looking For */}
            <div className="row mb-5">
              <div className="col-12">
                <h2 className="mb-3" style={{ color: '#222', fontWeight: '700' }}>Who We're Looking For</h2>
                <p className="mb-3" style={{ fontSize: '1rem' }}>We collaborate with:</p>
                <ul className="single-list-inner style-check mb-3">
                  {whoWeLookFor.map((item, index) => (
                    <li key={index} style={{ fontSize: '1rem', lineHeight: '1.8', marginBottom: '12px' }}>
                      <FaCheckCircle style={{ color: '#50af9b' }} /> {item}
                    </li>
                  ))}
                </ul>
                <p style={{ fontSize: '1rem', fontStyle: 'italic', color: '#555', marginTop: '20px' }}>
                  You don't need a perfect title — you need to think clearly and execute well.
                </p>
              </div>
            </div>

            {/* What You'll Get */}
            <div className="row mb-5">
              <div className="col-12">
                <h2 className="mb-4" style={{ color: '#222', fontWeight: '700' }}>What You'll Get</h2>
                <ul className="single-list-inner style-check mb-4">
                  {whatYouGet.map((item, index) => (
                    <li key={index} style={{ fontSize: '1rem', lineHeight: '1.8', marginBottom: '12px' }}>
                      <FaCheckCircle style={{ color: '#50af9b' }} /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA */}
            <div className="row">
              <div className="col-12 text-center">
                <div style={{ 
                  background: '#f8f9fa', 
                  padding: '40px 30px', 
                  borderRadius: '8px',
                  borderLeft: '4px solid #50af9b'
                }}>
                  <h2 className="mb-3" style={{ color: '#222' }}>Ready to Build?</h2>
                  <p className="mb-4" style={{ fontSize: '1rem', color: '#555' }}>
                    Send your background, interests, and what you're looking to build to:
                  </p>
                  <a 
                    href="mailto:careers@evolvelab.ca" 
                    style={{ 
                      fontSize: '1.2rem', 
                      fontWeight: '600', 
                      color: '#50af9b',
                      textDecoration: 'none'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#3d8a7a'}
                    onMouseLeave={(e) => e.target.style.color = '#50af9b'}
                  >
                    careers@evolvelab.ca
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterOne />
    </>
  );
};

export default Career;
